import styled, { css } from 'styled-components';
import colors from 'Styles/colors';
import { disableTextSelection } from 'Styles/effects/text';
import { ReactComponent as FRound } from 'Images/f_round.svg';

export const Wrapper = styled.div`
  width: 100%;
  height: 320px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgrounds.sidebarSubMenu};
  text-align: left;
  ${disableTextSelection}
  border-radius: 0;
  box-shadow: 0 2px 15px 0 ${({ theme }) => theme.shadows.agentsCard};
  ${({ selected, theme }) => selected === true && `
    border: 1px solid ${theme.borders.workspaceSelectedItem};
  `}
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.memoListItemTitle};
  width: calc(93% - 75px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 12px;
`;
Title.displayName = 'Title';

export const Status = styled.div`
flex: 0 0 auto;
width: ${(props) => props.width || '69px'};
max-width: ${(props) => props.width || '69px'};
margin-left: ${(props) => (props.noMargin ? '0' : '25px')};
margin-right: ${(props) => (props.noMargin ? '0' : '20px')};
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  height: 25px;
  color: ${colors.white};
  ${(props) => (props.value === 'offline'
    ? css`background: ${colors.blueGrey};`
    : css`background: ${colors.blueCerulean};`)
}
`;
Status.displayName = 'Status';

export const FaradayLogo = styled(FRound)``;
FaradayLogo.displayName = 'FaradayLogo';

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;
Header.displayName = 'Header';

export const CardMain = styled.div`
  padding: 28px 30px 0 28px;
`;
CardMain.displayName = 'CardMain';

export const CardFooter = styled.div`
  margin-top: auto;
  padding: 16px 30px 28px 28px;
  border-top: 1px solid ${({ theme }) => theme.borders.agentsBottom};
`;
CardFooter.displayName = 'CardFooter';

export const CustomStatus = styled(Status)`
  font-size: 10px;
  font-weight: 500;
  width: 49px;
  height: 20px;
  line-height: 2;
  margin: 0 0 0 auto;
  border-radius: 0;
`;
CustomStatus.displayName = 'CustomStatus';

export const DescriptionContent = styled.div`
  font-size: 11.5px;
  line-height: 1.55;
  color: ${({ theme }) => theme.text.workspaceItem};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(1.55em * 2);
  ${({ isEmpty }) => isEmpty && css`
    font-style: italic;
    opacity: 0.7;
  `}
`;
DescriptionContent.displayName = 'DescriptionContent';
